import { forwardRef } from "react";
import { SVGFillPath, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Close = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 28 28" ref={ref} {...props}>
      <SVGFillPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 2.83L25.17 0L14 11.17L2.83 0L0 2.83L11.17 14L0 25.17L2.83 28L14 16.83L25.17 28L28 25.17L16.83 14L28 2.83Z"
      />
    </SVGIconRoot>
  );
});
